import { useActiveProject } from './useActiveProject';

export type Mode = 'sales' | 'experience';

interface UseModeResult {
  mode: Mode;
  setMode: (mode: Mode) => void;
}

/**
 * Hook to get the current operational mode based on the active project.
 * The mode is now derived from the project settings, not set globally.
 * @returns {UseModeResult} The current mode and a setMode function (compatibility).
 */
export const useMode = (): UseModeResult => {
  const activeProject = useActiveProject(state => state.activeProject);

  // Default to 'experience' if no project is active or mode is not set
  const mode: Mode = (activeProject?.mode as Mode) || 'experience';

  const setMode = (newMode: Mode) => {
    console.warn("setMode is deprecated. Mode is now set per project in Project Settings.", newMode);
    // In a future update, this could update the project's mode via an API call
  };

  return { mode, setMode };
};